import React, { useMemo } from "react";
import { View } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { ButtonIcon } from "@lookiero/sty-psp-ui";
import { DOMAIN, I18nMessages, PREFIX } from "../../../i18n/i18n";
import { style as titleStyle } from "./Title.style";
const Title = ({ onPress }) => {
    const titleText = useI18nMessage({ domain: DOMAIN, id: I18nMessages.TITLE, prefix: PREFIX });
    const style = useMemo(() => titleStyle(), []);
    return (React.createElement(View, { style: style.container },
        React.createElement(Text, { level: 2, selectable: false, variant: "action" }, titleText),
        React.createElement(ButtonIcon, { name: "info", style: { button: style.buttonIcon }, testID: "info-button-icon", onPress: onPress })));
};
export { Title };
